// 简单顶栏路由
export const simpleHeaderRoutes = [/\/profile/];
// 校验注册流程路由白名单
export const notNeedSignupRoutes = ["/login", "/signup", "/ui", "/icons", /\/profile/];

// 路由是否匹配
export const isRouteMatch = (list, path) => {
  let match = list.includes(path) || window.location.href.includes("/profile");
  if (!match) {
    match = list.some((item) => {
      return item.test && item?.test(path);
    });
  }
  return match;
};
